import { faUserVneckHairLong, faGraduationCap, faPaw } from '@fortawesome/pro-light-svg-icons';

export const PageDetails = {
  systems: {
    id: 'systems',
    title: 'Systems',
    url: 'systems',
    breadcrumbs: [{ title: 'Dashboard', href: '/' }],
  },
  advisor: {
    id: 'advisor',
    page: 'advisor',
    title: 'Advisor',
    icon: faUserVneckHairLong,
    externalUrl: 'https://itsapps.odu.edu/advisor/',
    description:
      'The Monarch Advising Portal helps students connect with advisors, schedule appointments, and track academic progress through a streamlined, user-friendly interface.',
    visibleTo: 'advisor',
  },
  canvas: {
    id: 'canvas',
    page: 'canvas',
    title: 'Canvas',
    icon: '/img/logos/canvas.svg',
    externalUrl: 'https://canvas.odu.edu/',
    description:
      "Canvas is ODU's web-based learning management system used by instructors and students to access and manage online course learning materials.",
  },
  degreeWorks: {
    id: 'degreeWorks',
    page: 'degreeWorks',
    title: 'Degree Works',
    icon: faGraduationCap,
    externalUrl: 'https://dw-prod.ec.odu.edu/responsiveDashboard',
    description:
      'The Degree Works degree evaluation tool is designed to assist advisors and students with course planning, measuring progress toward program completion, and curriculum advising.',
  },
  gmail: {
    id: 'gmail',
    page: 'gmail',
    title: 'Gmail',
    icon: '/img/logos/gmail.svg',
    externalUrl: 'https://mail.google.com/a/odu.edu',
    description:
      'Gmail is a secure Google email platform that streamlines communication with powerful search tools, spam filtering, and integrates with campus Workspace apps.',
    visibleTo: 'gmail',
  },
  outlook: {
    id: 'outlook',
    page: 'outlook',
    title: 'Outlook',
    icon: '/img/logos/outlook.svg',
    externalUrl: 'https://outlook.odu.edu/',
    description:
      'Old Dominion University uses Microsoft Outlook as the official e-mail system for distributing course-related communications, policies, announcements and other information.',
    visibleTo: 'outlook',
  },
  leoOnline: {
    id: 'leoOnline',
    page: 'leoOnline',
    title: 'LeoOnline',
    icon: '/img/logos/leoOnline.svg',
    externalUrl: 'https://www.odu.edu/administrative-banner-systems/leo-online',
    description: 'Access LeoOnline for registration, financial aid, and student records.',
  },
  papers: {
    id: 'papers',
    page: 'papers',
    title: 'Papers',
    icon: '/img/logos/papers.svg',
    externalUrl: 'https://jobs.odu.edu/hr',
    description:
      "Papers is ODU's online recruitment, position management and performance management system.",
  },
  student360: {
    id: 'student360',
    page: 'student360',
    title: 'Student360',
    icon: '/img/logos/student360Blue.svg',
    externalUrl: 'https://success.odu.edu/',
    description:
      'Student 360 provides faculty with immediate access to comprehensive student information, including academic records, schedules, and advising notes.',
  },
  studentResources: {
    id: 'studentResources',
    page: 'studentResources',
    title: 'Student Resources',
    icon: faPaw,
    externalUrl: 'https://www.odu.edu/sees/student-resources',
    description: 'Find student resources and support services.',
  },
};
